// 体育页面初始化
import { useSportsMenuListData } from './useSportsMenuListData';

export const useSportsInit = () => {
  useSportsMenuListData();
};
